export default __webpack_public_path__ + "static/media/logotrilhasupretangular.d513fe6a.png";